import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({ title, message, onRetry }: ErrorStateProps) {
  return (
    <Box className="page-state error-state" role="alert" sx={{ textAlign: 'center', p: 4 }}>
      <Typography variant="h5" component="h2" gutterBottom>
        {title}
      </Typography>
      <Typography color="text.secondary">{message}</Typography>
      {onRetry && (
        <Button variant="contained" sx={{ mt: 2 }} onClick={onRetry}>
          Retry
        </Button>
      )}
    </Box>
  );
}
